import { Flex, Box, VStack, Text, HStack, Input, Button, IconButton, FormControl, FormLabel, Heading, Divider, Spinner, Checkbox, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Image, useToast } from '@chakra-ui/react';
import { useState, useEffect, useCallback } from 'react';
import { getLinkedToMe, getMyInvitations, deleteAcceptedInvitation, deletePendingInvitation, inviteUserByEmail, getUserDetail, updateUser, updatePersonal, getPersonalDetail } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { Form, useNavigate } from 'react-router-dom';
import LINE_QR_CODE_URL from '../assets/line_qr.png'; // 友だち追加用QRコード画像のパス（適宜差し替え）


export default function UserInfo({isAdmin=false}) {
    const { currentUser, tenantInfo } = useAuth();
    // --- ユーザ招待フォーム・一覧 ---
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviting, setInviting] = useState(false);
  const [inviteError, setInviteError] = useState('');
  const [myInvitations, setMyInvitations] = useState([]);
  const [deletingInviteId, setDeletingInviteId] = useState(null);
  const navigate = useNavigate();
  const [linkedToMe, setLinkedToMe] = useState([]);
  const [isParent, setIsParent] = useState(false);
  const [owner_email, setOwnerEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingLinkedToMe, setIsLoadingLinkedToMe] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  const [authCode, setAuthCode] = useState('認証コード作成中');
  const [lineLink, setLineLink] = useState(false);
  const toast = useToast();
 
  useEffect(() => {
    if (currentUser && tenantInfo?.tenant_id) {
      const authCode = tenantInfo.tenant_id + "." + currentUser.uid.slice(5, 11)
      setAuthCode(authCode)
    }
  }, [currentUser, tenantInfo]);

  useEffect(() => {
    const fetchLinkedToMe = async () => {
        const data = await getLinkedToMe();
        setLinkedToMe(data);
        setIsParent(data.length === 0);
        setOwnerEmail(data.length > 0 ? data[0].owner_email : null);
        setIsLoadingLinkedToMe(false);
    };
    setIsLoadingLinkedToMe(true);
    if(!isAdmin) {
      fetchLinkedToMe();
    } else {
    }
    setIsLoadingLinkedToMe(false);
  }, [currentUser]);

  // --- ユーザー情報フォーム ---
  const [form, setForm] = useState({
    name: '',
    phone: '',
    address: '',
    age: '',
    family: '',
    nickname: '',
    is_land_owner: false,
    construction_area: '',
  });
  const [isFormLoading, setIsFormLoading] = useState(false);

  const fetchUserInfo = useCallback(async () => {
    if (!currentUser) return;
    if (!isAdmin) {
      const userData = await getUserDetail(currentUser.uid);
      const personalData = await getPersonalDetail(currentUser.uid);  
      setForm({
      name: userData.name || '',
      phone: userData.phone || '',
      address: userData.address || '',
      age: userData.age || '',
      family: userData.family || '',
      is_land_owner: userData.is_land_owner || false,
      construction_area: userData.construction_area || '',
      nickname: personalData.nickname || '',
    });
    setLineLink(personalData.line_user_id || false);
    setIsLoading(false);
  } else {
    const personalData = await getPersonalDetail(currentUser.uid);
    setForm({
      nickname: personalData.nickname || '',
    });
    setLineLink(personalData.line_user_id || false);
    setIsLoading(false);
  }
  }, [currentUser]);

  const handleInvite = async () => {
    if (!currentUser) return;
    setInviting(true);
    setInviteError('');
    try {
      const response = await inviteUserByEmail(inviteEmail);
      if (response.status === 'pending') {
        setInviteEmail('');
        setInviteError('');
        await fetchMyInvitations();
      } else {
        setInviteError(response.message || '招待に失敗しました');
      }
    } catch (err) {
      console.error("招待処理中にエラーが発生しました:", err);
      setInviteError(err.message || '招待処理中にエラーが発生しました');
    } finally {
      setInviting(false);
    }
  };

  const fetchMyInvitations = async () => {
    if (!currentUser || isAdmin) return;
    try {
      const data = await getMyInvitations();
      setMyInvitations(data);
    } catch (err) {
      console.error("招待一覧の取得に失敗しました:", err);
      setInviteError(err.message || '招待一覧の取得に失敗しました');
    }
  };
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    if (e.target.type === 'checkbox') {
      setForm((prev) => ({ ...prev, [name]: checked }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFormLoading(true);
    try {
      await updatePersonal(currentUser.uid, { nickname: form.nickname });
      if ( form.age === '' ) {
        delete form.age;
      }
      delete form.nickname;
      await updateUser(currentUser.uid, { ...form });

    } catch (err) {
      console.error("ユーザー情報の更新に失敗しました:", err);
    } finally {
      setIsFormLoading(false);
    }
  };
  const onDeleteLineLink = async () => {
    if (!currentUser) return;
    try {
      await updatePersonal(currentUser.uid, { line_user_id: null });
      setLineLink(false);
    } catch (err) {
      console.error("LINE連携解除に失敗しました:", err);
      toast({
        title: 'LINE連携解除に失敗しました',
        description: err.message || 'LINE連携解除に失敗しました',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if(currentUser) {
      fetchUserInfo();
      fetchMyInvitations();
    }
  }, [currentUser, fetchUserInfo]);

  const handleDeletePendingInvite = async (id) => {
    if (!currentUser || !id) return;
    setDeletingInviteId(id);
    try {
      await deletePendingInvitation(id);
    } catch (err) {
      console.error("招待削除中にエラーが発生しました:", err);
      setInviteError(err.message || '招待削除中にエラーが発生しました');
    } finally {
      setDeletingInviteId(null);
    }
    try {
      fetchMyInvitations();
    } catch (err) {
      console.error("招待一覧の取得に失敗しました:", err);
      setInviteError(err.message || '招待一覧の取得に失敗しました');
    } finally {
      setDeletingInviteId(null);
    }
  };

  const handleDeleteAcceptedInvite = async (id) => {
    if (!currentUser || !id) return;
    setDeletingInviteId(id);
    try {
      await deleteAcceptedInvitation(id);
    } catch (err) {
      console.error("招待削除に失敗しました:", err);
      setInviteError(err.message || '招待削除に失敗しました');
    } finally {
      setDeletingInviteId(null);
    }
    try {
      fetchMyInvitations();
    } catch (err) {
      console.error("招待一覧の取得に失敗しました:", err);
      setInviteError(err.message || '招待一覧の取得に失敗しました');
    } finally {
      setDeletingInviteId(null);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/auth');
    } catch (err) {
      console.error("Logout Error:", err);
    }
  };
  if (isLoading || isLoadingLinkedToMe) {
    return <Spinner />;
  }

    return (
      <Flex direction="column" gap={4} width={{ base: '100%', md: '800px' }}>
        <HStack>
        <Button onClick={() => navigate(-1)} colorScheme="gray" variant="outline">← 戻る</Button>
        <Heading>お客様登録情報</Heading>
      </HStack>
       <Box 
            bg="gray.100"
            p={4}
            borderRadius="md"
            w="100%"
        >
        {!isAdmin && (
          <>
          <Text>
            お客様登録情報の入力が可能です。
          </Text>
          <Text>
            お客様情報にあわせてより良いお住まいの提案をさせていただきます。
          </Text>
          <Text>
            お客様のご家族の招待により、ご家族も一緒に間取り・設備選択することが可能です。
          </Text>
          </>
        )}
        {isAdmin && (
          <>
          <Text>
            ニックネームの入力・Line連携が可能です。
          </Text>
          <Text>
            ニックネームはチャットでの表示名に使用されます。
          </Text>
          <Text>
            Line連携すると、お客様から連絡があった際にLineに通知されます。
          </Text>
          </>
　      )}
        </Box>
        <Box>
          <Button bg="black" color="white" onClick={handleLogout}>
            ログアウト
          </Button>
        </Box>
        <Box bg="white" p={8} borderRadius="lg" boxShadow="lg">
          <Divider my={4} />
          <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
              {!isAdmin && (
                <>
              <Heading size="md" mb={2}>ご家族共有情報</Heading>
              <FormControl>
                <FormLabel>お名前(代表者様)</FormLabel>
                <Input name="name" value={form.name} onChange={handleChange} placeholder="例: 山田 太郎" />
              </FormControl>
              <FormControl>
                <FormLabel>電話番号</FormLabel>
                <Input name="phone" value={form.phone} onChange={handleChange} placeholder="例: 09012345678" maxLength={11} />
              </FormControl>
              <FormControl>
                <FormLabel>住所</FormLabel>
                <Input name="address" value={form.address} onChange={handleChange} placeholder="都道府県・市区町村・番地" />
              </FormControl>
              <FormControl>
                <FormLabel>年齢</FormLabel>
                <Input name="age" value={form.age} onChange={handleChange} placeholder="例: 35" type="number" min={0} />
              </FormControl>
              <FormControl>
                <FormLabel>家族構成</FormLabel>
                <Input name="family" value={form.family} onChange={handleChange} placeholder="例: 夫婦＋子2人" />
              </FormControl>
              <FormControl>
                <FormLabel>土地を所有していますか？</FormLabel>
                <Checkbox name="is_land_owner" value={form.is_land_owner} isChecked={!!form.is_land_owner} onChange={handleChange} />
              </FormControl>
              <FormControl>
                <FormLabel>建設予定地</FormLabel>
                <Input name="construction_area" value={form.construction_area} onChange={handleChange} placeholder="例: 大阪府堺市北区" />
              </FormControl>
              </>
              )}
              <Heading size="md" mb={2}>個別情報</Heading>
              <FormControl>
                <FormLabel>表示名</FormLabel>
                <Input name="nickname" value={form.nickname} onChange={handleChange} placeholder="例: たろう" />
              </FormControl>
              <FormControl>
                <Text>{lineLink ? 'LINE連携済み' : 'LINE連携未設定'}</Text>
                {!lineLink && (<Button colorScheme="green" onClick={onOpen}>
                  LINE連携する
                </Button>)
                }
                {lineLink && (<Button colorScheme="gray" onClick={onDeleteLineLink}>
                  LINE連携を解除する
                </Button>)
               }
              </FormControl>

              <Button type="submit" bg="black" color="white" isLoading={isFormLoading} w="full">送信</Button>
            </VStack>
          </form>
        </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>LINE連携</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box textAlign="center">
              <Box mb={4}>
                <div>まずは公式LINEを友だち追加してください</div>
                <Image src={LINE_QR_CODE_URL} alt="LINE友だち追加QR" mx="auto" boxSize="200px" />
              </Box>
              <Box mt={2}>
                <Text>
                  友だち追加後、Selectia公式LINEに下記の認証コードをLINEで送信してください
                  <Box mt={2} fontSize="xl" fontWeight="bold" color="green.600" border="1px dashed #aaa" p={2} borderRadius="md">
                    {authCode}
                  </Box>
                  <br />
                  送信後、しばらくするとLINE連携が有効になります。
                </Text>
              </Box>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>閉じる</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {!isAdmin && (
        <>
        <Divider my={4} />
        <Box bg="white" p={8} borderRadius="lg" boxShadow="lg">
          { !isParent && (
            <Text>{owner_email} 様のご家族アカウントです。</Text>
          ) }

          {isParent && (
            <>
            <VStack alignItems="flex-start">
              <Heading size="md">家族を招待</Heading>
              <HStack>
              <Input
                  size="md"
                  placeholder="メールアドレスを入力"
                  value={inviteEmail || ''}
                  onChange={e => setInviteEmail(e.target.value)}
                  isDisabled={inviting || myInvitations.length >= 5}
                width="250px"
                type="email"
              />
              <Button
                size="sm"
                bg="black"
                color="white"
                onClick={handleInvite}
                isLoading={inviting}
                isDisabled={!inviteEmail || myInvitations.length >= 5}
              >
                招待
              </Button>
              </HStack>
              {inviteError && (
                <Text fontSize="sm" color="red.500">{inviteError}</Text>
              )}
            </VStack>
            <VStack alignItems="flex-start">
              <Heading size="sm">招待中</Heading>
              <VStack align="start" spacing={0}>
              {myInvitations.map(invite => (
              <HStack key={invite.id} spacing={1}>
                  <Text fontSize="sm" color={invite.status === 'accepted' ? 'green.600' : 'gray.700'}>
                    {invite.invitee_email} {invite.status === 'accepted' ? '(承認済)' : '(招待中)'}
                  </Text>
                  <IconButton
                    size="sm"
                    icon={<span>×</span>}
                    aria-label="招待削除"
                    colorScheme="red"
                    variant="ghost"
                    onClick={(e) => {
                      if (invite.status === 'accepted') {
                        handleDeleteAcceptedInvite(invite.id);
                      } else {
                        handleDeletePendingInvite(invite.id);
                      }
                    }}
                    isDisabled={deletingInviteId === invite.id}
                  />
              </HStack>
              ))}
              {myInvitations.length === 0 && (
              <Text fontSize="sm" color="gray.400">（なし）</Text>
              )}
              </VStack>
            </VStack>
          </>
          )}
        </Box>  
        </>
      )}
      </Flex>
    );
}
